// extracted by mini-css-extract-plugin
export default {"cls1":"FocusedNav-cls1_yXh","cls2":"FocusedNav-cls2_APM FocusedNav-cls1_yXh"};